module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/glacier_national_park-06bdcc86d542db82c9fd4271271c4b55.jpg";